/**
 * Potential Redux Thunk action states
 */
export const STATUS_TYPES = {
  UNLOAD_STATE: 'notLoaded',
  INIT_STATE: 'initState',
  SUCCEED_STATE: 'succeedState',
  FAILED_STATE: 'failedState',
};

/**
 * Potential Shipment Stop Types.
 * Used in card-shipment-stops.js.
 */
export const STOP_TYPES = {
  origin: 'origin',
  inBetween: 'inBetween',
  destination: 'destination',
};

/**
 * Different badge types to be used in
 * badge.js
 */
export const BADGE_TYPES = {
  late: 'late',
};

/**
 * Different smart filter types to be used in
 * smart-filter.js
 */
export const SMART_FILTER_TYPES = {
  lateLoads: 'lateLoads',
  withinTwoHours: 'withinTwoHours',
  loadsWithProblems: 'loadsWithProblems',
  allLoads: 'allLoads',
};

/**
 * Different activity types to be used in
 * activity.js
 */
export const ACTIVITY_TYPES = {
  resolveProblem: 'resolveProblem',
  logProblem: 'logProblem',
  manualTrack: 'manualTrack',
  visibilityAppTrack: 'visibilityAppTrack',
  updateStatusBooked: 'Booked',
  updateStatusInTransit: 'In Transit',
  updateStatusAtConsignee: 'At Consignee',
  updateStatusAtShipper: 'At Shipper',
  updateStatusDelivered: 'Delivered',
  updateStatusDispatch: 'Dispatch',
  updateStatusPaperwork: 'Paperwork',
  updateStatusPickup: 'Pickup',
  visibilityAppStatusUpdate: 'visibilityAppStatusUpdate',
  internalTmsNote: 'tmsNote',
  internalTmsTrack: 'tmsTrack',
  bounce: 'Bounce',
};

/**
 * Different transit app statuses
 */
export const TRANSIT_APP_STATE = {
  installedTrackingNotStarted: 'Installed, Tracking Not Started',
  requestNotSent: 'Request Not Sent',
  requestSent: 'Request Sent',
  driverRefused: 'Driver Refused',
  tracking: 'Tracking',
  lostConnection: 'Lost Connection',
};

/**
 * Known visibility app names
 */
export const VISIBILITY_APP_NAME = {
  truckerTools: 'Trucker Tools',
  fourKites: 'FourKites',
};

/**
 * Known tracking event types
 */
export const TRACKING_EVENT_TYPES = {
  statusUpdate: 'Status Update',
  manualTrack: 'Manual Track',
  problemSet: 'Problem Set',
  problemResolution: 'Problem Resolution',
  automaticTrack: 'Automatic Track',
  visibilityAppStatusUpdate: 'Visibility App Status Update',
  tmsInternalNote: 'Transit (Internal) Note',
  tmsInternalTrack: 'Tracking Update',
  bounce: 'Bounce',
  rebooked: 'Rebooked',
};

/**
 * Bounce reason enum
 */
export const BOUNCE_REASONS = {
  breakdown: 'Breakdown',
  weather: 'Weather',
  previousLoad: 'Previous Load',
  noCapacity: 'No Capacity',
  driverIssue: 'Driver Issue',
  shipperError: 'Shipper Error/TONU',
  trailerRejected: 'Trailer Rejected',
  lumperReimbursement: 'Lumper Reimbursement',
};

/**
 * TL Tracking action types
 */
export const TL_TRACKING_ACTIONS = {
  trackManualEvent: 'Track Manual Event',
  logProblem: 'Log a Problem',
  resolveProblem: 'Resolve Problem',
  updateStatus: 'Update Status',
  bounceLoad: 'Bounce Load',
};

/**
 * LTL Tracking action types
 */
export const LTL_TRACKING_ACTIONS = {
  updateStatus: 'Update Status',
  trackDriverLocation: 'Track Driver Location',
  addNote: 'Add Note',
  logProblem: 'Log a Problem',
  resolveProblem: 'Resolve a Problem',
  markForReconsignment: 'Mark Reconsignmnet',
  markForConsolidation: 'Mark Consolidation',
  bounceLoad: 'Bounce Load',
};

/**
 * Tooltip messages
 */
export const TOOLTIP_MESSAGES = {
  'transit-tracker': 'Learn whether a Visibility App is currently active and tracking the load. You can also review the most recent driver location. Track a manual event in the “Key Tracking Actions on this Load” card.',
  'activity-history': 'Review prior activity on the load with the most recent updates on top. You can use the filters or checkbox to filter the Activity History log.',
  'last-human-update': 'Review the most recent action taken by a Track & Trace user on the load.',
  'load-problems': 'Review the current problems logged on the load. Additional notes can be found in the Activity History on the Load Details page. You can log or resolve a problem in the “Key Tracking Actions on this Load” card.',
  'load-status': 'Review the load’s current status. You can update the status in the “Key Tracking Actions on This Load” card.',
  'shipment-stop-info': 'Find information about the load’s pickup and drop-off locations and appointment times. You can also find notes for each location in the “Location Notes” tab.',
  'driver-truck-info': 'Review the current driver name and phone number along with the assigned truck and trailer numbers. You can edit this information directly in TMS.',
  'load-actions': 'Use these key actions to update the load’s status, log or resolve an existing problem, manually track a driver’s location or bounce the load. You can also add lumper information by logging a lumper reimbursement problem.',
  'search-bar': 'Search key information on a load (e.g. Load ID#, locations, carrier information, customer information, etc.)',
  'smart-filter-problems': 'Select to show only loads that currently have a logged problem. By default, the list will be sorted by # of problems and problem type (problems earlier in the life of a load will be prioritized on top).',
  'smart-filter-late': 'Select to show only loads that are past two hours late based on tracking information. By default, the list will be sorted by upcoming appointment date.',
  'smart-filter-within-two-hours': 'Select to show only loads that are within two hours (+ or -) to their next relevant appointment time. By default, the list will be sorted by loads closest to their appointment time.',
};

/**
 * Lock expiration states
 */
export const LOCK_EXPIRATION_STATES = {
  fresh: 0,
  expiring: 1,
  expired: 2,
  expirationAcknowledged: 3,
  expirationExtended: 4,
};

/**
 * Activity thread sorting options
 */
export const ACTIVITY_THREAD_SORT_OPTIONS = {
  asc: 'asc',
  desc: 'desc',
};

/**
 * Defined features in the application (to be used for feature flags)
 */
export const APP_FEATURES = {
  LTL: 'LTL',
};

/**
 * Default comment characters limit
 */
export const COMMENTS_CHARACTER_LIMIT = 500;

/**
 * Mode Types
 */
export const MODE_TYPES = {
  truckload: 'TL',
  lessThanTruckload: 'LTL',
};
